// import { format } from "date-fns";
import React, { useState, useEffect } from "react";
import Skeleton from "@mui/material/Skeleton";
import axiosLead from "../../../../services/lead";
import CardBirthday from "../cardBirthday";
import * as Styles from "../../styles";

interface Props {
  codigoCargo2013: string | null;
}

const SectionBirthdays = (props: Props) => {
  const [bdaysData, setbdaysData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    requestAniversariantes();
  }, []);

  const requestAniversariantes = async () => {
    // const formatedData = format(new Date(), "yyyy-MM-dd");
    setLoading(true);
    try {
      const response = await axiosLead.GetAniversariantes();
      setbdaysData(response.data.data);
    } catch (error: any) {
      console.log(error);
    }
    setLoading(false);
  };

  return (
    <div>
      <Styles.ShortcutsTitle className="titleBday">
        Aniversariantes do dia
      </Styles.ShortcutsTitle>
      {loading ? (
        <Skeleton variant="rectangular" width="100%" height={103} />
      ) : (
        <>
          {bdaysData?.length > 0 ? (
            <Styles.BirthdaysRow>
              {bdaysData?.map((bday: any) => {
                return (
                  <CardBirthday
                    codigoCargo2013={props.codigoCargo2013}
                    nome={bday?.nomeLead}
                    idLeadCorretor={bday?.idLeadCorretor}
                    idLead={bday?.idLead}
                    email1={bday?.email1}
                    email2={bday?.email1}
                    email3={bday?.email1}
                    telefone1={bday?.telefone1}
                    telefone2={bday?.telefone2}
                    telefone3={bday?.telefone3}
                  />
                );
              })}
            </Styles.BirthdaysRow>
          ) : (
            <Styles.Text style={{ marginLeft: 0 }}>
              Nenhum aniversariante para hoje
            </Styles.Text>
          )}
        </>
      )}
    </div>
  );
};

export default SectionBirthdays;
